import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "select"]
  static values = {
    initial: { type: Number, default: 0 },
    activeClasses: { type: String, default: "border-accent text-heading" },
    inactiveClasses: { type: String, default: "border-transparent text-body hover:text-heading hover:border-default" },
    urlParam: { type: String, default: "" }
  }

  connect() {
    const initialIndex = this.#resolveInitialTab()
    if (initialIndex !== 0) {
      this.switchToTab(initialIndex, false)
    }
  }

  switch(event) {
    const clickedTab = event.currentTarget
    const tabIndex = parseInt(clickedTab.dataset.tabIndex)
    this.switchToTab(tabIndex)
  }

  selectSwitch(event) {
    const option = event.target.options[event.target.selectedIndex]
    const tabIndex = parseInt(option.dataset.tabIndex)
    this.switchToTab(tabIndex)
  }

  switchToTab(tabIndex, updateUrl = true) {
    const activeClasses = this.activeClassesValue.split(" ").filter(Boolean)
    const inactiveClasses = this.inactiveClassesValue.split(" ").filter(Boolean)

    // Update tabs
    this.tabTargets.forEach((tab, index) => {
      if (index === tabIndex) {
        tab.classList.add(...activeClasses)
        tab.classList.remove(...inactiveClasses)
      } else {
        tab.classList.remove(...activeClasses)
        tab.classList.add(...inactiveClasses)
      }
    })

    // Update select (mobile)
    if (this.hasSelectTarget) {
      const options = this.selectTarget.options
      for (let i = 0; i < options.length; i++) {
        if (parseInt(options[i].dataset.tabIndex) === tabIndex) {
          this.selectTarget.selectedIndex = i
          break
        }
      }
    }

    // Update panels
    this.panelTargets.forEach((panel, index) => {
      if (index === tabIndex) {
        panel.classList.remove("hidden")
        panel.classList.add("block")
      } else {
        panel.classList.add("hidden")
        panel.classList.remove("block")
      }
    })

    // Update URL
    if (updateUrl && this.urlParamValue) {
      const tab = this.tabTargets[tabIndex]
      const paramValue = tab?.dataset.tabParam
      const url = new URL(window.location)
      if (paramValue && tabIndex !== 0) {
        url.searchParams.set(this.urlParamValue, paramValue)
      } else {
        url.searchParams.delete(this.urlParamValue)
      }
      history.replaceState(null, "", url)
    }
  }

  #resolveInitialTab() {
    if (this.urlParamValue) {
      const url = new URL(window.location)
      const paramValue = url.searchParams.get(this.urlParamValue)
      if (paramValue) {
        const index = this.tabTargets.findIndex(tab => tab.dataset.tabParam === paramValue)
        if (index !== -1) return index
      }
    }
    return this.initialValue
  }
}
